$(() => {
  const TIME_TO_WAIT = 24 * 7; // (HOURS * DAYS)
  const bookingFormDataDate = window.localStorage.getItem(
    'destroy_booking_form_data'
  );
  if (bookingFormDataDate) {
    const resetBookingFormDataDate = new Date(bookingFormDataDate).setHours(
      TIME_TO_WAIT,
      0,
      0,
      0
    );
    const resetCurrentDate = new Date().setHours(0, 0, 0, 0);
    const bookingFormDataIsOld =
      JSON.stringify(new Date(resetBookingFormDataDate)) <=
      JSON.stringify(new Date(resetCurrentDate));
    if (bookingFormDataIsOld) {
      window.localStorage.removeItem('totalNights');
      window.localStorage.removeItem('checkIn');
      window.localStorage.removeItem('checkOut');
      window.localStorage.removeItem('guests');
      window.localStorage.removeItem('firstName');
      window.localStorage.removeItem('lastName');
      window.localStorage.removeItem('email');
      window.localStorage.removeItem('phone');
      window.localStorage.removeItem('message');
      window.localStorage.removeItem('destroy_booking_form_data');
    }
  }
});
